import { Loader, Select, type SelectProps } from "@mantine/core";

import { SYSTEM_COLORS } from "@/configs/colorScheme";

export interface FormFieldSelectProps extends SelectProps {
  loading?: boolean;
}

export const FormFieldSelect = ({ loading, ...props }: FormFieldSelectProps) => {
  return (
    <Select
      allowDeselect={!props.required}
      clearable={!props.required}
      placeholder={typeof props.label === "string" ? props.label : undefined}
      checkIconPosition="right"
      maxDropdownHeight="16rem"
      searchable
      selectFirstOptionOnChange
      rightSection={loading ? <Loader size={18} /> : undefined}
      withAsterisk={(props.required && !props.readOnly) ?? undefined}
      variant={props.readOnly ? "unstyled" : undefined}
      styles={{
        label: {
          color: props.readOnly ? SYSTEM_COLORS.default : undefined,
        },
      }}
      {...props}
    />
  );
};

export default FormFieldSelect;
